export const BLANK_V2 = 'blank-v2';
export const CORRECT_ANSWERS = 'correct-answers';
export const CORRECT_ANSWER = 'correct-answer';
